/* eslint-disable @typescript-eslint/no-unused-vars */
import { AutocompleteWithLabel, SelectWithLabel } from '@adotel/components'
import { useLazyQuery, useQuery } from '@apollo/client'
import { MenuItem, Paper } from '@material-ui/core'
import { FC, useEffect } from 'react'

// import { RATEPLANS_QUERY } from '../../graphql/rateplans'
// import { ROOMTYPES_QUERY } from '../../graphql/roomtypes'
// import { getTranslate } from '../../localization'
import {
  CRSInventoryData,
  ProviderForInventory,
  RoomTypeForInventory
} from '../../../types/inventory'
// import { RatePlan } from '../../types/rateplan'
// import { RoomType } from '../../types/roomtype'
import useStyles from '../styles/InventorySecondaryFiltersBox.styles'
import InventoryProviderRow from './InventoryProviderRowMobile'

interface InventoryTableProviderProps {
  roomTypeData: RoomTypeForInventory | undefined
}
const InventoryTableProvider: FC<InventoryTableProviderProps> = ({
  roomTypeData
}) => {
  const classes = useStyles()

  return (
    <>
      {roomTypeData?.basicDetails.providers.map(
        (singleProvider: ProviderForInventory) => (
          <InventoryProviderRow
            key={singleProvider.basicDetails.id}
            name={singleProvider.basicDetails.name}
            availability={singleProvider.dataForEachDate.map((date) => ({
              date: date.date,
              value: date.availability.value,
              manual: date.availability.manual
            }))}
          />
        )
      )}
    </>
  )
}

export default InventoryTableProvider
